// A regra do preco da perna do catalogo do fornecedor — [DA-636], pedido dele em 28/08/2026:
// *"Quando ouver preenchido Embalabem e Quantidade, o preco se torna obrigatorio"*.
//
// Mora aqui, e nao em cada lado, porque ela precisa valer na TELA (que recusa antes de mandar) e no
// SERVIDOR (que e' quem garante — o bundle do navegador so troca com recarga, entao aba aberta
// antes do deploy segue mandando o corpo antigo). Duas copias divergem; esta e' uma so.
//
// O que a regra conserta: ate 28/08 a perna NOVA sem preco era descartada no front antes do envio,
// junto com a embalagem e a quantidade recem-digitadas — o Salvar respondia "Item atualizado" e os
// dois campos nunca saiam do navegador (medido: `fornecedor_catalogo` id 3912, PUT 200 as 09:19:08,
// embalagem e quantidade NULL). Agora ou a perna esta completa, ou a recusa aparece.

/** Os tres numeros da perna, ja normalizados por quem chama (cada lado tem o seu parse). */
export interface PernaPreco {
  /** Vazio/nulo = a filial nao declarou embalagem. */
  embalagem: string | null | undefined;
  /** Numero ja parseado; `null`/`NaN` = campo vazio. */
  quantidade_embalagem: number | null | undefined;
  /** Numero ja parseado; `null`/`NaN`/0 = sem preco. */
  preco_unitario: number | null | undefined;
}

const preenchido = (n: number | null | undefined): boolean => n != null && Number.isFinite(n) && n > 0;

/**
 * A perna esta com Embalagem E Qtd preenchidas mas SEM preco?
 *
 * `true` = recusar a gravacao. A saida que a recusa tem que nomear ([DA-560]) e' apagar os dois
 * campos: sem eles a linha grava so a identidade do item, que e' a compra informativa da [DA-309].
 */
export function pernaSemPrecoObrigatorio(p: PernaPreco): boolean {
  const temEmbalagem = !!(p.embalagem && String(p.embalagem).trim() !== '');
  return temEmbalagem && preenchido(p.quantidade_embalagem) && !preenchido(p.preco_unitario);
}

/**
 * A perna tem alguma coisa dentro? So sobe pro servidor a que tem — mas o criterio NAO pode ser so
 * o preco: era exatamente assim que embalagem e quantidade digitadas eram jogadas fora em silencio.
 */
export function pernaTemConteudo(p: PernaPreco): boolean {
  return !!(p.embalagem && String(p.embalagem).trim() !== '')
    || preenchido(p.quantidade_embalagem)
    || preenchido(p.preco_unitario);
}
